<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title class="mat-title-small">
      {{ quoteLabel() }}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ul>
    <li>Can quote online: {{ quote().online }}</li>
    <li>Request status: {{ quote().request_status }}</li>
  </ul>
  @if (carrierEngineUrl()) {
    <emperor-link-button [href]="carrierEngineUrl()" target="_blank">
      <span class="link-button-text">View in Carrier Engine</span>
    </emperor-link-button>
  }
</mat-expansion-panel>
